KROWN.themeName = 'Kingdom';
KROWN.themeVersion = '5.0.0';

// Shopify events

const executeOnceOnDomContentLoaded = () =>
{

	// input helpers

	document.querySelectorAll('input').forEach(elm =>
	{
		elm.addEventListener('change', e =>
		{
			if (e.target.value != '')
			{
				e.target.classList.add('filled');
			} else
			{
				e.target.classList.remove('filled');
			}
		})
	});
	document.querySelectorAll('input[type="search"]').forEach(elm => { elm.value = '' });

	// a11y tab helper 

	let activeElement = document.activeElement;
	document.addEventListener('keyup', e =>
	{
		if (e.keyCode == window.KEYCODES.TAB)
		{
			if (activeElement.classList.contains('focus') && e.target != activeElement)
			{
				activeElement.classList.remove('focus');
			}
			if (e.target.classList.contains('regular-select-cover') ||
				e.target.classList.contains('search-field') ||
				e.target.classList.contains('product-item__link') ||
				e.target.classList.contains('content-slider') ||
				e.target.classList.contains('blog-item__header') ||
				e.target.classList.contains('toggle__title') ||
				e.target.tagName == 'INPUT'
			)
			{
				activeElement = e.target;
				e.target.classList.add('focus');
			}
		}
	});

	// newsletter has jump

	if (window.location.search == '?customer_posted=true')
	{
		setTimeout(() =>
		{
			window.scroll({
				top: document.querySelector('form .alert').offsetTop - 250,
				behavior: 'smooth'
			});
		}, 300);
	} else if (window.location.pathname.includes('/challenge'))
	{
		setTimeout(() =>
		{
			window.scroll({
				top: 0,
				behavior: 'auto'
			});
		}, 300);
	}

}

if (document.readyState !== 'loading')
{
	executeOnceOnDomContentLoaded();
} else
{
	document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart)
{

	window.refreshCart = () =>
	{

		fetch('?section_id=cart-helper')
			.then(response => response.text())
			.then(text =>
			{

				const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
				const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
				const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

				const cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormInnerHTML;
				cartItems.ajaxifyCartItems();
				document.querySelector('[data-header-cart-count]').textContent = cartItems.querySelector('[data-cart-count]').textContent;

				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

				document.querySelector('.sidebar__cart').show();

			})

	}

}

// Custom gallery arrows for product page

const initGalleryArrows = () =>
{
	const gallery = document.querySelector('.product-gallery-main') || document.querySelector('.product-gallery');
	if (!gallery) return;

	const cssSlider = gallery.querySelector('css-slider');
	if (!cssSlider) return;

	gallery.style.position = 'relative';
	gallery.style.overflow = 'visible';

	const btnStyle = 'position:absolute;top:50%;transform:translateY(-50%);z-index:100;background:rgba(0,0,0,0.5);color:white;border:none;padding:10px 15px;cursor:pointer;font-size:20px;border-radius:4px;opacity:0;transition:opacity 0.3s ease;';

	const prevBtn = document.createElement('button');
	prevBtn.innerHTML = '&#8592;';
	prevBtn.setAttribute('aria-label', 'Predchádzajúci obrázok');
	prevBtn.style.cssText = btnStyle;

	const nextBtn = document.createElement('button');
	nextBtn.innerHTML = '&#8594;';
	nextBtn.setAttribute('aria-label', 'Nasledujúci obrázok');
	nextBtn.style.cssText = btnStyle;

	gallery.appendChild(prevBtn);
	gallery.appendChild(nextBtn);

	// Funkcia ktorá nastaví pozíciu šípok podľa skutočnej veľkosti obrázka
	const updateArrowPositions = () =>
	{
		const activeSlide = gallery.querySelector('.css-slide-active') || gallery.querySelector('.css-slide');
		if (!activeSlide) return;

		const figure = activeSlide.querySelector('figure.lazy-image');
		if (!figure) return;

		const galleryRect = gallery.getBoundingClientRect();
		const figureRect = figure.getBoundingClientRect();

		// Vypočítaj pozíciu obrázka relatívne k galérií
		const leftOffset = figureRect.left - galleryRect.left;
		const rightOffset = galleryRect.right - figureRect.right;

		prevBtn.style.left = (leftOffset + 15) + 'px';
		nextBtn.style.right = (rightOffset + 15) + 'px';
	};

	// Nastav pozície hneď a po načítaní
	updateArrowPositions();
	window.addEventListener('resize', updateArrowPositions);
	setTimeout(updateArrowPositions, 500);

	// Show arrows on hover
	gallery.addEventListener('mouseenter', () =>
	{
		prevBtn.style.opacity = '1';
		nextBtn.style.opacity = '1';
	});

	gallery.addEventListener('mouseleave', () =>
	{
		prevBtn.style.opacity = '0';
		nextBtn.style.opacity = '0';
	});

	prevBtn.addEventListener('click', () => cssSlider.changeSlide('prev'));
	nextBtn.addEventListener('click', () => cssSlider.changeSlide('next'));
};

setTimeout(initGalleryArrows, 3000);
